module.exports = __webpack_public_path__ + "static/media/home-layout-menu-three.f2f2090e.png";